import { render, staticRenderFns } from "./addAutoServer.vue?vue&type=template&id=1ab81c3c&scoped=true&"
import script from "./addAutoServer.vue?vue&type=script&lang=js&"
export * from "./addAutoServer.vue?vue&type=script&lang=js&"
import style0 from "./addAutoServer.vue?vue&type=style&index=0&id=1ab81c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab81c3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ab81c3c')) {
      api.createRecord('1ab81c3c', component.options)
    } else {
      api.reload('1ab81c3c', component.options)
    }
    module.hot.accept("./addAutoServer.vue?vue&type=template&id=1ab81c3c&scoped=true&", function () {
      api.rerender('1ab81c3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/automaticServer/components/addAutoServer.vue"
export default component.exports